import { createContext, useState } from "react";
export const AllContext = createContext();
export const AllProvider = ({ children }) => {
  const [widthCh, setWidthCh] = useState("");
  const value = { widthCh, setWidthCh };
  return <AllContext.Provider value={value}>{children}</AllContext.Provider>;
};
